export var getLegalHubLinks = function getLegalHubLinks(legalHub) {
  return legalHub.map(function (link) {
    return {
      href: link === null || link === void 0 ? void 0 : link.path,
      title: (link === null || link === void 0 ? void 0 : link.title) || '',
      withOneTrust: link.path.includes('manage-cookies') || link.path.includes('ccpa')
    };
  });
};